import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, resolveDirective as _resolveDirective, createVNode as _createVNode, withDirectives as _withDirectives, unref as _unref, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, withCtx as _withCtx } from "vue";
const _hoisted_1 = {
  class: "setting-popup"
};
const _hoisted_2 = {
  class: "popup-main"
};
const _hoisted_3 = {
  class: "popup-header"
};
const _hoisted_4 = {
  class: "popup-title"
};
const _hoisted_5 = {
  class: "popup-content"
};
const _hoisted_6 = {
  class: "setting-wrap"
};
const _hoisted_7 = {
  class: "setting-item"
};
const _hoisted_8 = {
  class: "setting-text"
};
const _hoisted_9 = /*#__PURE__*/_createElementVNode("div", {
  class: "divider"
}, null, -1);
const _hoisted_10 = {
  class: "setting-item"
};
const _hoisted_11 = {
  class: "setting-text"
};
import { ref, computed, inject } from 'vue';
import { useI18n } from 'vue-i18n';
import { storeToRefs } from 'pinia';
import Switch from '@/components/Common/Switch';
import { useAudio } from "@/hooks";
import { useSettingsStore, useUserStore } from '@/store';
import packageJson from '/package.json';
export default {
  __name: 'Setting',
  emits: ['onClose'],
  setup(__props, {
    emit: __emit
  }) {
    const emit = __emit;
    const {
      playAudio,
      pauseAudio
    } = useAudio();
    const MyDialog = inject('myDialog');
    const {
      t
    } = useI18n();
    const settingsStore = useSettingsStore();
    const {
      version
    } = storeToRefs(settingsStore);
    const userStore = useUserStore();
    const h5Version = ref(packageJson.version);
    const isSound = computed({
      get: () => settingsStore.isSound,
      set: value => {
        settingsStore.setSound(value);
      }
    });
    const isMusic = computed({
      get: () => settingsStore.isMusic,
      set: value => {
        settingsStore.setMusic(value);
        if (value) {
          playAudio('bgm');
        } else {
          pauseAudio('bgm');
        }
      }
    });
    const doLogout = () => {
      MyDialog.confirm({
        message: t('msg.logout')
      }).then(() => {
        // on confirm
        userStore.logout();
      }).catch(() => {});
    };
    const reloadApp = () => {
      location.href = `${location.origin}?t=${new Date().getTime()}`;
    };
    return (_ctx, _cache) => {
      const _component_van_image = _resolveComponent("van-image");
      const _component_van_popup = _resolveComponent("van-popup");
      const _directive_audio = _resolveDirective("audio");
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(_component_van_popup, {
        show: true,
        "close-on-click-overlay": false,
        "lock-scroll": false
      }, {
        default: _withCtx(() => [_createElementVNode("div", _hoisted_2, [_createElementVNode("div", _hoisted_3, [_createElementVNode("div", _hoisted_4, _toDisplayString(_ctx.$t('tabbar.setting')), 1), _withDirectives(_createVNode(_component_van_image, {
          class: "close-icon",
          src: require('@/assets/img/common/popup-close.png'),
          onClick: _cache[0] || (_cache[0] = $event => emit('onClose'))
        }, null, 8, ["src"]), [[_directive_audio, void 0, "close"]])]), _createElementVNode("div", _hoisted_5, [_createElementVNode("div", _hoisted_6, [_createElementVNode("div", _hoisted_7, [_createElementVNode("div", _hoisted_8, _toDisplayString(_ctx.$t('setting.music')), 1), _withDirectives(_createVNode(_unref(Switch), {
          modelValue: isMusic.value,
          "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => isMusic.value = $event)
        }, null, 8, ["modelValue"]), [[_directive_audio]])]), _hoisted_9, _createElementVNode("div", _hoisted_10, [_createElementVNode("div", _hoisted_11, _toDisplayString(_ctx.$t('setting.sound')), 1), _withDirectives(_createVNode(_unref(Switch), {
          modelValue: isSound.value,
          "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => isSound.value = $event)
        }, null, 8, ["modelValue"]), [[_directive_audio]])])]), _withDirectives((_openBlock(), _createElementBlock("div", {
          class: "logout-btn",
          onClick: doLogout
        }, [_createTextVNode(_toDisplayString(_ctx.$t('common.logout')), 1)])), [[_directive_audio]]), _createElementVNode("div", {
          class: "app-version",
          onClick: reloadApp
        }, "V" + _toDisplayString(h5Version.value) + _toDisplayString(_unref(version) ? ` (${_unref(version)})` : ''), 1)])])]),
        _: 1
      })]);
    };
  }
};